import styled from 'styled-components';
import Flex from './Flex';
import {border, color} from 'styled-system';

export const Form = styled.form`

`

export const FormContent = styled.ul`
  list-style-type: none;
  padding: 1em;
  max-width: 800px;
  margin: 0 auto;

  > li:not(:last-child) {
    margin-bottom: 20px;
  }
  
  ${border}

`

export const FormItem = styled.li`

  textarea {
    padding: .5em;
    background-color: ${props => props.theme.colors.cardBackground};
    color: ${props => props.theme.colors.formText};
    border-color: ${props => props.theme.colors.footer};
    border-style: solid;
    border-width: 1px;
    width: 100%;
  }
  
  width: 100%;
`

export const FormPair = styled.li`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  
  button {
    margin-left: auto;
    padding: .5em 1em;
    text-transform: uppercase;
    letter-spacing: .09em;
    border-radius: 2px;
  }

  input:not([type='checkbox']), textarea {
    padding: .5em;
    background-color: ${props => props.theme.colors.cardBackground};
    color: ${props => props.theme.colors.formText};
    border-color: ${props => props.theme.colors.footer};
    border-style: solid;
    border-width: 0 0 1px 0 ;
  }

  input:not([type='checkbox']):focus {
    outline: none !important;
    border-color: ${props => props.theme.colors.formText};
  }

  p {
    margin: 0;
  }

  label + * {
    flex: 1 0 220px;
  }

  label, p {
    color: ${props => props.theme.colors.formText};
    padding: .5em;
    font-weight: 300;
    letter-spacing: .09em;
    text-transform: uppercase;
  }

  & > label, p {
    flex: 1 0 120px;
    max-width: 220px;
  }
  
  ${color}
`

export const FormButtons = styled(Flex)`
  display: flex;

  margin-top: 1em;
  
  * {
    margin-top: 1em;
  }
  
  * + * {
    margin-left: 1.5em;
  }
  
  align-items: center;
  justify-content: center;
`